const ASSET_VALUATION_CURRENCIES = ['BTC', 'ETH', 'SOL', 'BNB']
const DECIMAL_TEXT_RE = /^[+-]?(?:\d+(?:\.\d+)?|\.\d+)$/

function toNumber(value) {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null
  }
  if (value === null || value === undefined) {
    return null
  }
  const text = String(value).trim()
  if (!DECIMAL_TEXT_RE.test(text)) {
    return null
  }
  const numberValue = Number(text)
  return Number.isFinite(numberValue) ? numberValue : null
}

function toPositiveNumber(value) {
  const numberValue = toNumber(value)
  return numberValue && numberValue > 0 ? numberValue : null
}

function toNonNegativeNumber(value) {
  const numberValue = toNumber(value)
  return numberValue !== null && numberValue >= 0 ? numberValue : null
}

function normalizeCurrencyName(value) {
  if (!value) return ''
  const name = String(value).trim().toUpperCase()
  return ASSET_VALUATION_CURRENCIES.indexOf(name) > -1 ? name : ''
}

function getCoinCurrencyId(row) {
  if (!row) return ''
  return row.ID || row.id || row.CurrencyId || row.currency_id || row.currencyId || ''
}

function getTradeCurrencyId(row) {
  if (!row) return ''
  if (row.CurrencyId || row.currency_id || row.currencyId) {
    return row.CurrencyId || row.currency_id || row.currencyId
  }
  if (row.Currency && row.Currency.ID) return row.Currency.ID
  if (row.currency && row.currency.ID) return row.currency.ID
  return ''
}

function getCurrencyShortName(row) {
  if (!row) return ''
  if (row.ShortName) return row.ShortName
  if (row.short_name) return row.short_name
  if (row.Name) return row.Name
  if (row.name) return row.name
  if (row.Currency && row.Currency.ShortName) return row.Currency.ShortName
  if (row.currency && row.currency.ShortName) return row.currency.ShortName
  return ''
}

function buildCurrencyIdNameMap(coinRows) {
  return (coinRows || []).reduce((map, row) => {
    const shortName = normalizeCurrencyName(getCurrencyShortName(row))
    const id = getCoinCurrencyId(row)
    if (shortName && id) {
      map[String(id)] = shortName
    }
    return map
  }, {})
}

function getTradePrice(row) {
  if (!row) return null
  return toPositiveNumber(row.Price || row.price || row.Close || row.close)
}

function buildAssetValuationPriceMap(tradeRows, coinRows) {
  const currencyIdNameMap = buildCurrencyIdNameMap(coinRows)
  return (tradeRows || []).reduce((map, row) => {
    const id = getTradeCurrencyId(row)
    const shortName = normalizeCurrencyName(getCurrencyShortName(row)) || currencyIdNameMap[String(id)]
    const price = getTradePrice(row)
    if (shortName && price && !map[shortName]) {
      map[shortName] = price
    }
    return map
  }, {})
}

function calculateAssetValuation(usdtAmount, targetCurrency, priceMap) {
  const amount = toNonNegativeNumber(usdtAmount)
  const currency = normalizeCurrencyName(targetCurrency)
  const price = currency ? toPositiveNumber(priceMap && priceMap[currency]) : null
  if (amount === null || !price) {
    return null
  }
  return amount / price
}

function formatAssetValuation(value) {
  const numberValue = toNonNegativeNumber(value)
  if (numberValue === null) {
    return ''
  }
  return numberValue.toFixed(8).replace(/\.?0+$/, '')
}

function getAssetValuationDisplay(usdtAmount, targetCurrency, priceMap) {
  const amount = calculateAssetValuation(usdtAmount, targetCurrency, priceMap)
  return amount === null ? '' : formatAssetValuation(amount)
}

module.exports = {
  ASSET_VALUATION_CURRENCIES,
  buildAssetValuationPriceMap,
  calculateAssetValuation,
  formatAssetValuation,
  getAssetValuationDisplay
}
